import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u401642836/domains/easyareacodes.com/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
